"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bids = [];
exports.asks = [];
exports.setBids = function (bidsArg) {
  exports.bids = bidsArg;
};
exports.setAsks = function (asksArg) {
  exports.asks = asksArg;
};